<template>
	<div ref="el" data-component="landing" data-page="Index.page">
		<svg width="0" height="0" viewBox="0 0 122 44" style="position: absolute">
			<defs>
				<clipPath id="menu-clip-path" clipPathUnits="objectBoundingBox" transform="scale(0.0081967 0.022727)">
					<path
						d="M122 19.846C122 21.715 121.346 23.525 120.15 24.9619L106.713 41.1159C105.194 42.9432 102.94 44 100.563 44H8C3.58172 44 0 40.4183 0 36V8C0 3.58172 3.58172 0 8 0H114C118.418 0 122 3.58172 122 8V19.846Z"
					/>
				</clipPath>
			</defs>
		</svg>

		<ShaderCanvas>
			<Header v-bind="getSection('header')" />

			<div ref="menuIcon" class="menu-icon" @click="scroller && scroller.scrollTo(0)">
				<div class="menu-wrapper">
					<div class="blur-layer"></div>
					<svg width="122" height="44" viewBox="0 0 122 44" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M122 19.846C122 21.715 121.346 23.525 120.15 24.9619L106.713 41.1159C105.194 42.9432 102.94 44 100.563 44H8C3.58172 44 0 40.4183 0 36V8C0 3.58172 3.58172 0 8 0H114C118.418 0 122 3.58172 122 8V19.846Z"
							fill="#201914"
							fill-opacity="0.4"
						/>
						<path
							d="M66.4199 25.3528C66.4199 28.7374 68.2454 30.1404 70.7028 30.1404C73.1602 30.1404 74.9033 28.7374 74.9033 25.3528V13.3836H78.2543V25.4625C78.2543 30.4994 75.2825 33 70.7028 33C66.1231 33 63.0689 30.4934 63.0689 25.4625V13.3836H66.4229V25.3528H66.4199ZM62.4605 32.644H58.9713L57.3634 28.0225H49.4004L47.7925 32.644H44.3591L51.311 13.3865H55.4586L62.4663 32.644H62.4605ZM91.2938 28.6009L96.338 13.3836H101V32.6411H97.9194V17.6729L92.793 32.6411H89.7653L84.583 17.756V32.6411H81.473V13.3836H86.1644L91.2909 28.6009H91.2938ZM21.1078 21.363C23.2331 21.363 25.1761 22.5763 26.1285 24.4955L29.7734 31.855C29.9263 32.1694 29.6999 32.5373 29.356 32.5373H9.4675C9.1324 32.5373 8.90606 32.1902 9.03833 31.8787L13.2624 21.9385C13.4093 21.5914 13.7474 21.366 14.1236 21.366H21.1108L21.1078 21.363ZM32.0016 8.76794C32.1867 8.40011 32.7129 8.42681 32.857 8.8154L37.0839 20.1854C37.175 20.4316 37.1604 20.7045 37.0457 20.9388L32.1103 30.8998C31.9398 31.2469 31.446 31.2469 31.2726 30.8998L27.4101 23.1072C26.6194 21.5143 26.6194 19.6337 27.4101 18.0407L32.0016 8.77387V8.76794ZM50.3292 25.3795H56.4375L53.3833 16.5754L50.3292 25.3795ZM30.1438 7C30.4877 7 30.7141 7.36783 30.5612 7.68226L26.1255 16.6347C25.1731 18.5539 23.2301 19.7671 21.1049 19.7671H14.6498C14.3059 19.7671 14.0795 19.3993 14.2324 19.0849L19.9614 7.51911C20.1202 7.20171 20.4435 7 20.7992 7H30.1438Z"
							fill="#FFEBC4"
						/>
					</svg>
				</div>
			</div>

			<main>
				<!-- <Problem v-bind="getSection('problem')" /> -->
				<!-- <Solution v-bind="getSection('solution')" /> -->
				<Features v-bind="getSection('features')" />
				<Products v-bind="getSection('products')" />
				<!-- <WhyAum v-bind="getSection('whyAum')" /> -->
			</main>

			<Footer v-bind="footer" />
		</ShaderCanvas>
	</div>
</template>

<script setup>
import { gsap } from 'gsap/all'
import { Header, Problem, Solution, Features, Products, WhyAum } from './sections'
import { ShaderCanvas } from '~/components/primitives'
import { Footer } from '~/components/sections'

const props = defineProps({
	sections: { type: Array, default: undefined },
	footer: { type: Object, default: undefined },
})

const el = ref(null)
const menuIcon = ref(null)
const context = inject('pageContext')
const scroller = inject('$scroller')

const getSection = (section) =>
	props.sections.find(
		(el) => (el.internalTitle && el.internalTitle.replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : '')).replace(/^(.)/, (m) => m.toLowerCase()) === section) || el._type == section
	)

const setup = () => {}
const init = () => {
	gsap.fromTo(
		menuIcon.value,
		{
			x: 5,
			opacity: 0,
		},
		{
			x: 0,
			opacity: 1,
			duration: 1.5,
			ease: 'expo.out',
			delay: 1.3,
		}
	)
}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.ready.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='landing'] {
	position: relative;

	.menu-icon {
		position: sticky;
		top: rs(36, 36);
		padding-left: var(--grid-margin);
		z-index: 10;
		height: 0;
		width: 0;

		margin-top: -128px;

		@include max-width($lg) {
			margin-top: -106px;
		}

		@include max-width($sm) {
			margin-top: -80px;
		}

		@include max-width($xxs) {
			margin-top: -66px;
		}

		:hover {
			cursor: pointer;
		}

		.menu-wrapper {
			position: relative;
			width: 122px;
			height: 44px;

			.blur-layer {
				position: absolute;
				inset: 0;
				backdrop-filter: blur(12px);
				-webkit-backdrop-filter: blur(12px);
				clip-path: url(#menu-clip-path);
			}

			svg {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: block;
			}
		}
	}

	main {
		margin-top: 128px;

		@include max-width($lg) {
			margin-top: 106px;
		}

		@include max-width($sm) {
			margin-top: 80px;
		}

		@include max-width($xxs) {
			margin-top: 66px;
		}
	}
}
</style>
